import React from 'react';
import { Flex, Img } from 'pounceV2';
import { useTheme } from '@mui/material';
import logoDark from 'Assets/panther-minimal-logo.svg';
import logoLight from 'Assets/panther-minimal-logo-light.svg';

const EditorLoaderV3 = () => {
  const theme = useTheme();
  const logo = theme.palette.mode === 'light' ? logoLight : logoDark;

  return (
    <Flex justify="center" align="center" width="100%" height="100%" pt={8}>
      <Img src={logo} alt="Panther logo" nativeHeight={80} />
    </Flex>
  );
};

export default EditorLoaderV3;
